import React from 'react';
import { PageHeader } from '../../components/admin/PageHeader';
import { ProcessDiagram } from '../../components/presentation/ProcessDiagram';
export function ProcessInfographic() {
  return <div data-id="element-1490" data-mp="22nh8mehd86jf">
      <PageHeader flag title="ডিএমপি এআই প্রসিকিউশন নোটিশ যাচাই প্রক্রিয়া" subtitle="AI ক্যামেরা থেকে নাগরিকের হাতে যাচাইযোগ্য নোটিশ — ১৬ ধাপের প্রস্তাবিত প্রক্রিয়া" data-id="element-1491" data-mp="22npkq45nz7tk" />
      <ProcessDiagram data-id="element-1492" data-mp="2cm6k9pio4ur8" />
    </div>;
}